import { useMatch } from 'react-router-dom';

function useAppId() {
  const match = useMatch('/apps/:id');

  return match?.params?.id;
}

export { useAppId };
